import { render, staticRenderFns } from "./pendingShopLook.vue?vue&type=template&id=a8a32566&scoped=true"
import script from "./pendingShopLook.vue?vue&type=script&lang=js"
export * from "./pendingShopLook.vue?vue&type=script&lang=js"
import style0 from "./pendingShopLook.vue?vue&type=style&index=0&id=a8a32566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a32566",
  null
  
)

export default component.exports